import { AlbumType } from "@common/admin/use-album_taxonomies";

export const GENRE_MODEL = 'genre';

export interface Genre {
  id: number;
  name: string;
  color: string;
  display_name?: string;
  model_type: 'genre';
  image?: string;
  album_types?: AlbumType[];
}
